<template>

    <button class="bg-transparent text-red-600 link bg-transparent px-3 py-1 rounded inline-block hover:shadow cursor-pointer mx-3" @click="confirm()">
        <span v-if="icon"><i class="fal" :class="(loading == href ? 'fa-spinner fa-spin' : 'fa-' + icon) + (this.$slots.default ? ' mr-1' : '')"></i></span>
        <slot></slot>
    </button>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    mixins: [Helpers],

    props: {
        href: null,
        method: null,
        icon: null,
        confirmMessage: {
            Type: String,
            default: 'Weet je het zeker?'
        }
    },

    methods: {
        confirm(){
            if (confirm(this.confirmMessage)) {
                this.setLoading(this.href)
                this.$inertia.delete(this.href);
            }
        }
    }
};
</script>

<style>
.link {
    transition: all, 0.2s;
}
</style>
